import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faPlus,
  faTrophy,
  faBullseye,
  faChessBoard,
  faHandPaper,
  faBasketball,
  faUserNinja,
  faFire,
  faDumbbell,
  faHands,
  faFlagCheckered,
  faStar,
  faPersonRunning,
  faCrown,
  faEye
} from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

import { AddHeader } from "../../components/AddHeader";
import { ExerciseTypeMark } from "../../components/ExerciseTypeMark";
import { ExerciseAddLayout } from "./ExerciseAddLayout";
import { gettype } from "../../components/funtionsBD/Mainservice";
import { exerciseTypeIconSrc } from "../../utils/exerciseTypeIcon";
import { isPersonalizedExerciseType, isSubtypeFreeExerciseType } from "../../utils/teExecutionType";
import Loader from "../../components/Loading/Loader";
import { currentAppLanguage } from "../../utils/appLanguages";

export const E1 = () => {
  const [list, setlist] = useState();
  const [load, setload] = useState(true);

  const navigate = useNavigate();
  const location = useLocation();
  const data = location.state;
  const { t } = useTranslation();
  const currentlng = currentAppLanguage();

  useEffect(() => {
    if (data?.typeid && (data?.cbid || data?.subtypeid || isSubtypeFreeExerciseType({ type_name_en: data.type_name_en }))) {
      navigate("/Exerciseslist", { replace: true, state: data });
      return;
    }
    typelist();
  }, []);

  const typelist = async () => {
    try {
      const response = await gettype();
      setlist(response.data.data);
      setload(false);
    } catch (error) {
      console.log(error);
      setload(false);
    }
  };

  /**
   * Get the appropriate icon for each exercise type
   */
  /**
   * Get the appropriate icon for each exercise type
   */
  const getExerciseTypeIcon = (typeNameEn) => {
    const iconMap = {
      'Personalized': faUserNinja,                    // Personalized - any exercise
      'Match': faTrophy,                              // Trophy for competitive matches
      'Technic Regularity Beginner': faBullseye,     // Target for precision/regularity beginner
      'Technic Regularity Advanced': faBullseye,     // Target for precision/regularity advanced
      'Technical Gesture Beginner': faBullseye,      // Target for technical gesture beginner
      'Technical Gesture Advanced': faBullseye,      // Target for technical gesture advanced
      'Footwork Transition': faBullseye,             // Target for footwork transition
      'Game Situation': faChessBoard,                 // Chess board for game situations
      'Service': faHandPaper,                         // Hand for service
      'Multiball': faBasketball,                      // Basketball for multiball
      'Shadow Training': faUserNinja,                 // Ninja for shadow training
      'Warmup': faFire,                               // Fire for warmup
      'Drill': faDumbbell,                            // Dumbbell for drills
      'Streaching': faHands,                          // Hands for stretching
      'Challenges': faFlagCheckered,                  // Checkered flag for challenges
      'Personalized': faStar,                         // Star for personalized - any exercise
      'Off-table exercises': faPersonRunning,           // Running for off-table / physical exercises
      'King of the table': faCrown,                     // Crown for king of the table
      'Visualisation': faEye,                           // Eye for visualisation
      // Legacy support (in case old names still exist in DB)
      'Technic Regularity': faBullseye,               // Old name for backward compatibility
      'Challenge': faFlagCheckered                    // Old name for backward compatibility
    };
    
    // Return the icon for the type, or default to faPlus if not found
    return iconMap[typeNameEn] || faPlus;
  };

  return (
    <ExerciseAddLayout>
      <AddHeader title={t("addex")} />
      <section className="exadd-hero">
        <p className="exadd-kicker">{t("pickExerciseType") || "Choose a type"}</p>
        <p className="exadd-lead">
          {t("pickExerciseTypeHint") ||
            "Pick how this training block should work. You can refine the catalogue next."}
        </p>
      </section>
      <div className="exercise_session_div exadd-choices">
        {list?.map((i, index) => (
          <button
            key={i.type_id || index}
            type="button"
            className="session_add_box exadd-choice"
            onClick={() => {
              const state = {
                typeid: i.type_id,
                type: i[`type_name_${currentlng}`],
                type_name_en: i.type_name_en,
                sessionid: data?.sessionid,
                grpid: data?.grpid,
                tsg_id: data?.tsg_id,
                te_id: data?.te_id,
              };
              if (isPersonalizedExerciseType(i)) {
                navigate("/PersonalizedTrainingSlot", { state });
              } else if (isSubtypeFreeExerciseType(i)) {
                navigate("/Exerciseslist", {
                  state: { ...state, subtypeid: null, subtype: null },
                });
              } else {
                navigate("/SelectTableExercises", { state });
              }
            }}
          >
            {(() => {
              const typeIcon = exerciseTypeIconSrc(i);
              return (
                <div
                  className={`session-image-add exadd-choice__icon${
                    typeIcon ? " exadd-choice__icon--type" : ""
                  }`}
                  aria-hidden="true"
                >
                  {typeIcon ? (
                    <ExerciseTypeMark src={typeIcon} />
                  ) : (
                    <FontAwesomeIcon icon={getExerciseTypeIcon(i.type_name_en)} />
                  )}
                </div>
              );
            })()}
            <div className="session-addinfo exadd-choice__copy">
              <h3>{i[`type_name_${currentlng}`]} </h3>
            </div>
          </button>
        ))}
      </div>
      {load && <Loader />}
    </ExerciseAddLayout>
  );
};
